export default "__VITE_ASSET__BqeQftSV__"